import { render, staticRenderFns } from "./info-rx-prescription.vue?vue&type=template&id=30ed433e&scoped=true&"
import script from "./info-rx-prescription.vue?vue&type=script&lang=js&"
export * from "./info-rx-prescription.vue?vue&type=script&lang=js&"
import style0 from "./info-rx-prescription.vue?vue&type=style&index=0&id=30ed433e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ed433e",
  null
  
)

export default component.exports